import React from 'react';
import { Box } from '@mui/material';
import { dashboardTokens as t } from './tokens';

export default function Card({ children, padded = true, sx = {}, ...rest }) {
    return (
        <Box
            {...rest}
            sx={{
                backgroundColor: t.color.surface,
                border: `1px solid ${t.color.border}`,
                borderRadius: `${t.radius.lg}px`,
                boxShadow: t.shadow.sm,
                padding: padded ? 3 : 0,
                ...sx,
            }}
        >
            {children}
        </Box>
    );
}
